// extracted by mini-css-extract-plugin
export var card = "_96-c";
export var checkmark = "_96-k";
export var childrenContainer = "_96-6";
export var container = "_96-b";
export var disabled = "_96-9";
export var disabledChildren = "_96-a";
export var focused = "_96-1";
export var gray = "_96-s";
export var green = "_96-p";
export var icon = "_96-g";
export var iconWrapper = "_96-8";
export var imageCircle = "_96-u";
export var large = "_96-5";
export var lg = "_96-j";
export var listItemContainer = "_96-0";
export var md = "_96-i";
export var medium = "_96-4";
export var menu = "_96-f";
export var nonInteractiveBadge = "_96-m";
export var red = "_96-q";
export var rightArea = "_96-7";
export var sectionContainer = "_96-e _96-b";
export var selected = "_96-d";
export var sm = "_96-h";
export var small = "_96-3";
export var statusDot = "_96-o";
export var statusDotContainer = "_96-n";
export var text = "_96-l";
export var transparent = "_96-t";
export var xs = "_96-2";
export var yellow = "_96-r";